import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'platform',
    loadComponent: () => import('./pages/platform/platform.component').then(m => m.PlatformComponent)
  },
  {
    path: 'products',
    loadComponent: () => import('./pages/products/products.component').then(m => m.ProductsComponent)
  },
  {
    path: 'pricing',
    loadComponent: () => import('./pages/pricing/pricing.component').then(m => m.PricingComponent)
  },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent)
  },
  {
    path: 'tenant-delete-request',
    loadComponent: () => import('./pages/tenant-delete-request/tenant-delete-request.component').then(m => m.TenantDeleteRequestComponent)
  },
  {
    path: 'downloads',
    loadComponent: () => import('./pages/downloads/downloads.component').then(m => m.DownloadsComponent)
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/markdown-cms-page/markdown-cms-page.component').then(m => m.MarkdownCmsPageComponent),
    data: { basePageKey: 'privacy' }
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/markdown-cms-page/markdown-cms-page.component').then(m => m.MarkdownCmsPageComponent),
    data: { basePageKey: 'terms' }
  },
  {
    path: 'cookies',
    loadComponent: () => import('./pages/markdown-cms-page/markdown-cms-page.component').then(m => m.MarkdownCmsPageComponent),
    data: { basePageKey: 'cookies' }
  },
  {
    path: 'blog',
    loadComponent: () => import('./pages/blog/blog-list/blog-list.component').then(m => m.BlogListComponent)
  },
  {
    path: 'blog/:slug',
    loadComponent: () => import('./pages/blog/blog-post/blog-post.component').then(m => m.BlogPostComponent)
  },
  {
    path: '**',
    redirectTo: ''
  }
];

